/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1MylibraryPeoplePersonidEnrollments200,
  GetApiV1MylibraryPeoplePersonidEnrollments401,
  GetApiV1MylibraryPeoplePersonidEnrollments500,
  GetApiV1MylibraryPeoplePersonidEnrollmentsPathParams,
  GetApiV1MylibraryPeoplePersonidEnrollmentsQueryParams,
  GetApiV1MylibraryPeoplePersonidEnrollmentsQueryResponse,
} from "../../types/myLibraryPessoasController/GetApiV1MylibraryPeoplePersonidEnrollments.ts";
import { myLibraryEnrollmentViewModelSchema } from "../myLibraryEnrollmentViewModelSchema.ts";

export const getApiV1MylibraryPeoplePersonidEnrollmentsPathParamsSchema =
  z.object({
    personId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1MylibraryPeoplePersonidEnrollmentsPathParams>;

export const getApiV1MylibraryPeoplePersonidEnrollmentsQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1MylibraryPeoplePersonidEnrollmentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1MylibraryPeoplePersonidEnrollments200Schema = z.array(
  z.lazy(() => myLibraryEnrollmentViewModelSchema),
) as unknown as ToZod<GetApiV1MylibraryPeoplePersonidEnrollments200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1MylibraryPeoplePersonidEnrollments401Schema =
  z.any() as unknown as ToZod<GetApiV1MylibraryPeoplePersonidEnrollments401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1MylibraryPeoplePersonidEnrollments500Schema =
  z.any() as unknown as ToZod<GetApiV1MylibraryPeoplePersonidEnrollments500>;

export const getApiV1MylibraryPeoplePersonidEnrollmentsQueryResponseSchema =
  z.lazy(
    () => getApiV1MylibraryPeoplePersonidEnrollments200Schema,
  ) as unknown as ToZod<GetApiV1MylibraryPeoplePersonidEnrollmentsQueryResponse>;
